import { Pipe, PipeTransform } from '@angular/core';

import { NumericType } from '../../../shared/types';
import { LocalizationService } from '../../../shared/services';

@Pipe({
  name: 'currentNumeric',
  pure: false,
})
export class CurrentNumericPipe implements PipeTransform {
  constructor(private localization: LocalizationService) {}

  transform(numberOfNumeric: number = 0, numericType: NumericType): string {
    return this.localization.getCurrentNumeric(numberOfNumeric, numericType);
  }
}
